import React, { useState, useEffect } from "react";
import { CameraImage, File, book } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import ExerciseCard, { ExerciseCardProps } from "../../components/exercise-card";
import ChatFooter from "../../components/chat-footer";
import { useNavigate } from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import "./choose-exercise.scss";
import { TrackingService } from "../../services/tracking/tracking.service";
import { useUserStore } from "../../utils/userStore";
import { resetExericeStore } from "../../utils/utils";
import ChooseExerciseWithHistory from "../choose-exercise-with-history";

interface Message {
  text: string;
  isBot: boolean;
  timestamp: Date;
}

export default function Index() {
  const { t } = useLayoutContext();
  const navigate = useNavigate();
  const { ROUTERS_PATH } = RouterConstant;
  const [inputMessage, setInputMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const trackingServiceInstance = new TrackingService();
  const { justLoggedIn, setJustLoggedIn, user_attributes } = useUserStore();

  if (user_attributes?.has_exercise_history) {
    return <ChooseExerciseWithHistory />;
  }

  useEffect(() => {
    resetExericeStore();
    setSessionId(Date.now().toString(36) + Math.random().toString(36).substr(2));

    if (justLoggedIn) {
      trackingServiceInstance.trackEvent("user_logged_in", { source: "login" });
      setJustLoggedIn(false);
    }
  }, []);


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    navigate(ROUTERS_PATH.CHAT, {
      state: {
        api: "TalkWithChat",
        payload: { message: inputMessage },
        from: "choose-exercise"
      }
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      setInputMessage((prev) => prev + "\n");
    }
  };

  const handleCaptureExercise = () => {
    navigate(`${ROUTERS_PATH.CAPTUREEXERCISE}?sessionId=${sessionId}`);
  };

  const cardItems: ExerciseCardProps[] = [
    {
      title: t("card1Title"),
      description: t("card1Des"),
      imgSrc: CameraImage,
      buttonText: t("card1ButtonText"),
      color: "blue",
      link: "CAPTUREEXERCISE",
      onClick: handleCaptureExercise,
    },
    {
      title: t("card2Title"),
      description: t("card2Des"),
      imgSrc: File,
      buttonText: t("card2ButtonText"),
      color: "green",
      link: "SEARCHEXRCISE" as keyof typeof RouterConstant.ROUTERS_PATH,
    },
    {
      title: t("card3Title"),
      description: t("card3Des"),
      imgSrc: book,
      buttonText: t("card3ButtonText"),
      color: "purple",
      link: "SELFTESTSTART" as keyof typeof RouterConstant.ROUTERS_PATH,
    },
  ];

  return (
    <div className="full-head-template choose-exercise-page">
      <div className="exercise-cards">
        {cardItems.map((item, index) => (
          <ExerciseCard key={index} {...item} />
        ))}
      </div>
      <ChatFooter
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        handleSubmit={handleSubmit}
        handleKeyDown={handleKeyDown}
        isLoading={isLoading}
        placeholderText={t("chatInputPlaceHolder")}
        isSendDisabled={inputMessage.trim().length < 10}
      />
    </div>
  );
}